<jsg-multi-row-panel>
  <jsg-single-row-panel first>
    <div first>
      <div>Remedy sought</div>
      <div>{{ remedySought }}</div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel second>
    <div first>
      <div>Contested</div>
      <div>{{ contestedType }}</div>
    </div>
    <div second>
      <div>Preferred hearing method</div>
      <div>{{ hearingMethod }}</div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel third>
    <div first>
      <div>Special requirements</div>
      <div
        *ngIf="
          specialRequirementsSelection &&
            specialRequirementsSelection.length === 0;
          else specialRequirementsBlock
        "
        class="section-text"
      >
        ——
      </div>
      <ng-template #specialRequirementsBlock>
        <div *ngFor="let requirement of specialRequirementsSelection">
          <div>
            {{ requirement?.description }}
          </div>
        </div>
      </ng-template>
    </div>
    <div second>
      <div>Other</div>
      <div>{{ specialRequirementNotes | incomplete }}</div>
    </div>
  </jsg-single-row-panel>
</jsg-multi-row-panel>
